export const COUNTRIES = [
  { name: "United States of America", code: "US", numeric: "840" },
  { name: "United Kingdom", code: "GB", numeric: "826" },
  { name: "Albania", code: "AL", numeric: "008" },
  { name: "Algeria", code: "DZ", numeric: "012" },
  { name: "Andorra", code: "AD", numeric: "020" },
  { name: "Angola", code: "AO", numeric: "024" },
  { name: "Antigua and Barbuda", code: "AG", numeric: "028" },
  { name: "Argentina", code: "AR", numeric: "032" },
  { name: "Armenia", code: "AM", numeric: "051" },
  { name: "Australia", code: "AU", numeric: "036" },
  { name: "Austria", code: "AT", numeric: "040" },
  { name: "Azerbaijan", code: "AZ", numeric: "031" },
  { name: "Bahamas", code: "BS", numeric: "044" },
  { name: "Bahrain", code: "BH", numeric: "048" },
  { name: "Bangladesh", code: "BD", numeric: "050" },
  { name: "Barbados", code: "BB", numeric: "052" },
  { name: "Belgium", code: "BE", numeric: "056" },
  { name: "Belize", code: "BZ", numeric: "084" },
  { name: "Benin", code: "BJ", numeric: "204" },
  { name: "Bhutan", code: "BT", numeric: "064" },
  { name: "Bolivia", code: "BO", numeric: "068" },
  { name: "Bosnia and Herzegovina", code: "BA", numeric: "070" },
  { name: "Botswana", code: "BW", numeric: "072" },
  { name: "Brazil", code: "BR", numeric: "076" },
  { name: "Brunei", code: "BN", numeric: "096" },
  { name: "Bulgaria", code: "BG", numeric: "100" },
  { name: "Burkina Faso", code: "BF", numeric: "854" },
  { name: "Burundi", code: "BI", numeric: "108" },
  { name: "Cabo Verde", code: "CV", numeric: "132" },
  { name: "Cambodia", code: "KH", numeric: "116" },
  { name: "Cameroon", code: "CM", numeric: "120" },
  { name: "Canada", code: "CA", numeric: "124" },
  { name: "Central African Republic", code: "CF", numeric: "140" },
  { name: "Chad", code: "TD", numeric: "148" },
  { name: "Chile", code: "CL", numeric: "152" },
  { name: "China", code: "CN", numeric: "156" },
  { name: "Colombia", code: "CO", numeric: "170" },
  { name: "Comoros", code: "KM", numeric: "174" },
  { name: "Congo (Congo-Brazzaville)", code: "CG", numeric: "178" },
  { name: "Costa Rica", code: "CR", numeric: "188" },
  { name: "Croatia", code: "HR", numeric: "191" },
  { name: "Cyprus", code: "CY", numeric: "196" },
  { name: "Czechia", code: "CZ", numeric: "203" },
  { name: "Democratic Republic of the Congo", code: "CD", numeric: "180" },
  { name: "Denmark", code: "DK", numeric: "208" },
  { name: "Djibouti", code: "DJ", numeric: "262" },
  { name: "Dominica", code: "DM", numeric: "212" },
  { name: "Dominican Republic (the)", code: "DO", numeric: "214" },
  { name: "Ecuador", code: "EC", numeric: "218" },
  { name: "Egypt", code: "EG", numeric: "818" },
  { name: "El Salvador", code: "SV", numeric: "222" },
  { name: "Equatorial Guinea", code: "GQ", numeric: "226" },
  { name: "Eritrea", code: "ER", numeric: "232" },
  { name: "Estonia", code: "EE", numeric: "233" },
  { name: "Eswatini", code: "SZ", numeric: "748" },
  { name: "Ethiopia", code: "ET", numeric: "231" },
  { name: "Fiji", code: "FJ", numeric: "242" },
  { name: "Finland", code: "FI", numeric: "246" },
  { name: "France", code: "FR", numeric: "250" },
  { name: "Gabon", code: "GA", numeric: "266" },
  { name: "Gambia", code: "GM", numeric: "270" },
  { name: "Georgia", code: "GE", numeric: "268" },
  { name: "Germany", code: "DE", numeric: "276" },
  { name: "Ghana", code: "GH", numeric: "288" },
  { name: "Greece", code: "GR", numeric: "300" },
  { name: "Grenada", code: "GD", numeric: "308" },
  { name: "Guatemala", code: "GT", numeric: "320" },
  { name: "Guinea", code: "GN", numeric: "324" },
  { name: "Guinea-Bissau", code: "GW", numeric: "624" },
  { name: "Guyana", code: "GY", numeric: "328" },
  { name: "Haiti", code: "HT", numeric: "332" },
  { name: "Holy See", code: "VA", numeric: "336" },
  { name: "Honduras", code: "HN", numeric: "340" },
  { name: "Hungary", code: "HU", numeric: "348" },
  { name: "Iceland", code: "IS", numeric: "352" },
  { name: "India", code: "IN", numeric: "356" },
  { name: "Indonesia", code: "ID", numeric: "360" },
  { name: "Iraq", code: "IQ", numeric: "368" },
  { name: "Ireland", code: "IE", numeric: "372" },
  { name: "Isle of Man", code: "IM", numeric: "833" },
  { name: "Israel", code: "IL", numeric: "376" },
  { name: "Italy", code: "IT", numeric: "380" },
  { name: "Jamaica", code: "JM", numeric: "388" },
  { name: "Japan", code: "JP", numeric: "392" },
  { name: "Jordan", code: "JO", numeric: "400" },
  { name: "Kazakhstan", code: "KZ", numeric: "398" },
  { name: "Kenya", code: "KE", numeric: "404" },
  { name: "Kiribati", code: "KI", numeric: "296" },
  { name: "Kuwait", code: "KW", numeric: "414" },
  { name: "Kyrgyzstan", code: "KG", numeric: "417" },
  { name: "Laos", code: "LA", numeric: "418" },
  { name: "Latvia", code: "LV", numeric: "428" },
  { name: "Lebanon", code: "LB", numeric: "422" },
  { name: "Lesotho", code: "LS", numeric: "426" },
  { name: "Liberia", code: "LR", numeric: "430" },
  { name: "Liechtenstein", code: "LI", numeric: "438" },
  { name: "Lithuania", code: "LT", numeric: "440" },
  { name: "Luxembourg", code: "LU", numeric: "442" },
  { name: "Madagascar", code: "MG", numeric: "450" },
  { name: "Malawi", code: "MW", numeric: "454" },
  { name: "Malaysia", code: "MY", numeric: "458" },
  { name: "Maldives", code: "MV", numeric: "462" },
  { name: "Mali", code: "ML", numeric: "466" },
  { name: "Malta", code: "MT", numeric: "470" },
  { name: "Marshall Islands", code: "MH", numeric: "584" },
  { name: "Mauritania", code: "MR", numeric: "478" },
  { name: "Mauritius", code: "MU", numeric: "480" },
  { name: "Mexico", code: "MX", numeric: "484" },
  { name: "Micronesia", code: "FM", numeric: "583" },
  { name: "Moldova", code: "MD", numeric: "498" },
  { name: "Monaco", code: "MC", numeric: "492" },
  { name: "Mongolia", code: "MN", numeric: "496" },
  { name: "Montenegro", code: "ME", numeric: "499" },
  { name: "Morocco", code: "MA", numeric: "504" },
  { name: "Mozambique", code: "MZ", numeric: "508" },
  { name: "Myanmar", code: "MM", numeric: "104" },
  { name: "Namibia", code: "NA", numeric: "516" },
  { name: "Nauru", code: "NR", numeric: "520" },
  { name: "Nepal", code: "NP", numeric: "524" },
  { name: "Netherlands", code: "NL", numeric: "528" },
  { name: "New Zealand", code: "NZ", numeric: "554" },
  { name: "Nicaragua", code: "NI", numeric: "558" },
  { name: "Niger", code: "NE", numeric: "562" },
  { name: "Nigeria", code: "NG", numeric: "566" },
  { name: "Norway", code: "NO", numeric: "578" },
  { name: "Oman", code: "OM", numeric: "512" },
  { name: "Pakistan", code: "PK", numeric: "586" },
  { name: "Palau", code: "PW", numeric: "585" },
  { name: "Palestine", code: " State of", numeric: "275" },
  { name: "Panama", code: "PA", numeric: "591" },
  { name: "Papua New Guinea", code: "PG", numeric: "598" },
  { name: "Paraguay", code: "PY", numeric: "600" },
  { name: "Peru", code: "PE", numeric: "604" },
  { name: "Philippines", code: "PH", numeric: "608" },
  { name: "Poland", code: "PL", numeric: "616" },
  { name: "Portugal", code: "PT", numeric: "620" },
  { name: "Qatar", code: "QA", numeric: "634" },
  { name: "Romania", code: "RO", numeric: "642" },
  { name: "Rwanda", code: "RW", numeric: "646" },
  { name: "Saint Kitts and Nevis", code: "KN", numeric: "659" },
  { name: "Saint Lucia", code: "LC", numeric: "662" },
  { name: "Saint Vincent and the Grenadines", code: "VC", numeric: "670" },
  { name: "Samoa", code: "WS", numeric: "882" },
  { name: "San Marino", code: "SM", numeric: "674" },
  { name: "Sao Tome and Principe", code: "ST", numeric: "678" },
  { name: "Saudi Arabia", code: "SA", numeric: "682" },
  { name: "Senegal", code: "SN", numeric: "686" },
  { name: "Serbia", code: "RS", numeric: "688" },
  { name: "Seychelles", code: "SC", numeric: "690" },
  { name: "Sierra Leone", code: "SL", numeric: "694" },
  { name: "Singapore", code: "SG", numeric: "702" },
  { name: "Slovakia", code: "SK", numeric: "703" },
  { name: "Slovenia", code: "SI", numeric: "705" },
  { name: "Solomon Islands", code: "SB", numeric: "090" },
  { name: "Somalia", code: "SO", numeric: "706" },
  { name: "South Africa", code: "ZA", numeric: "710" },
  { name: "South Korea", code: "KR", numeric: "410" },
  { name: "South Sudan", code: "SS", numeric: "728" },
  { name: "Spain", code: "ES", numeric: "724" },
  { name: "Sri Lanka", code: "LK", numeric: "144" },
  { name: "Suriname", code: "SR", numeric: "740" },
  { name: "Sweden", code: "SE", numeric: "752" },
  { name: "Switzerland", code: "CH", numeric: "756" },
  { name: "Tajikistan", code: "TJ", numeric: "762" },
  { name: "Tanzania", code: "TZ", numeric: "834" },
  { name: "Thailand", code: "TH", numeric: "764" },
  { name: "Timor-Leste", code: "TL", numeric: "626" },
  { name: "Togo", code: "TG", numeric: "768" },
  { name: "Tonga", code: "TO", numeric: "776" },
  { name: "Trinidad and Tobago", code: "TT", numeric: "780" },
  { name: "Tunisia", code: "TN", numeric: "788" },
  { name: "Turkey", code: "TR", numeric: "792" },
  { name: "Turkmenistan", code: "TM", numeric: "795" },
  { name: "Tuvalu", code: "TV", numeric: "798" },
  { name: "Uganda", code: "UG", numeric: "800" },
  { name: "Ukraine", code: "UA", numeric: "804" },
  { name: "United Arab Emirates", code: "AE", numeric: "784" },
  { name: "Uruguay", code: "UY", numeric: "858" },
  { name: "Uzbekistan", code: "UZ", numeric: "860" },
  { name: "Vanuatu", code: "VU", numeric: "548" },
  { name: "Vietnam", code: "VN", numeric: "704" },
  { name: "Yemen", code: "YE", numeric: "887" },
  { name: "Zambia", code: "ZM", numeric: "894" },
  { name: "Zimbabwe", code: "ZW", numeric: "716" },
];

export default {};
